import React, {
    ReactNode,
    createContext,
    useContext
} from 'react';
import EventEmitter from '../utils/EventEmitter';
import { InitOptions } from '../types/player';

interface PlayerBuilderContextType {
    schema: any;
    defaultOptions: InitOptions;
    formOptions: InitOptions;
    diffOptions: InitOptions;
    css: string;
    js: string;
    optionsOverride: string;
}

export const Context = createContext<PlayerBuilderContextType | undefined>(undefined);

export const Provider = (props: {
    children: ReactNode, 
    schema: any,
    defaultOptions: InitOptions,
    formOptions: InitOptions,
    diffOptions: InitOptions
    css: string,
    js: string,
    optionsOverride: string
}) => {
    
    const { schema, defaultOptions, formOptions, diffOptions, css, js, optionsOverride } = props;


    return (
        <Context.Provider
            value={{
                schema, defaultOptions, formOptions, diffOptions, css, js, optionsOverride
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export const usePlayerBuilderContext = (): PlayerBuilderContextType => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('usePlayerContext must be used within a Provider');
    }
    return context;
};